import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Errors, SellerService, LeaderboardService, FileService } from 'src/app/core';
import { managerApi } from 'src/app/config';

@Component({
  selector: 'app-sales-tab',
  templateUrl: './sales-tab.component.html',
})
export class SalesTabComponent implements OnInit {
  @Input() userProfile: any = null;
  @Input() pamData: any = '';

  @Output() showActivity = new EventEmitter<void>();

  bonusIncentives: any;
  errors: Errors = { errors: {} };

  quarterList: any[] = [];
  selectedQuarter: any = null;
  quarterDropdownItems: any[] = [];
  viewQuarterDropdownItems: any[] = [];

  previewModalOpen = false;
  previewUrl = '';
  previewSafeUrl: any = null;
  previewQuarterLabel = '';
  previewLoading = false;
  previewApiUrl = '';
  downloadLoading = false;

  constructor(
    private sanitizer: DomSanitizer,
    private sellerService: SellerService,
    private leaderboardService: LeaderboardService,
    private fileService: FileService,
  ) {}

  ngOnInit() {
    this.getSalesChallenges();
    this.loadQuarterList();
  }

  getSalesChallenges() {
    const params = {
      region: this.userProfile.company.region,
      beGeoId: this.pamData === ''
        ? this.userProfile.company.beGeoId
        : this.pamData.pamBeGeoIdsDTO.beGeoIds[0].beGeoId,
      page: 0,
      size: 8,
      console: localStorage.getItem('selectedRole') === 'manager' ? 'LEADER' : 'SELLER',
    };
    this.sellerService.getBonusIncentives(params).subscribe(
      (data: any) => { this.bonusIncentives = data; },
      (err: any) => { this.errors = err; }
    );
  }

  loadQuarterList() {
    const req = 'includeCurrentQuarter=true&noOfPreviousQuarters=1';
    this.leaderboardService.getquaterListForDistributorChgFlag(req).subscribe((data: any) => {
      this.quarterList = data || [];
      if (this.quarterList.length > 0) {
        this.selectedQuarter = this.quarterList[0];
      }
      this.quarterDropdownItems = this.quarterList.map((q: any, i: number) => ({
        label: this.getQuarterLabel(q),
        value: q,
        checked: i === 0,
      }));
      this.viewQuarterDropdownItems = this.quarterList.map((q: any, i: number) => ({
        label: this.getQuarterLabel(q),
        value: q,
        checked: i === 0,
      }));
    });
  }

  getQuarterLabel(q: any): string {
    if (q.currentQuarter) { return 'Current Quarter (' + q.fiscalQuarter + ')'; }
    if (q.previousQuarter) { return 'Previous Quarter (' + q.fiscalQuarter + ')'; }
    return q.fiscalQuarter;
  }

  onQuarterDropdownChange(item: any) {
    const quarter = item.value;
    this.selectedQuarter = quarter;
    this.quarterDropdownItems = this.quarterList.map((q: any) => ({
      label: this.getQuarterLabel(q),
      value: q,
      checked: q === this.selectedQuarter,
    }));
    const apiUrl = managerApi.eligibleProductsDownload
      + '?fiscalYear=' + quarter.fiscalYear
      + '&quarter=' + quarter.fiscalQuarter;
    this.downloadLoading = true;
    this.fileService.downloadFile(apiUrl).subscribe(
      () => { this.downloadLoading = false; },
      () => { this.downloadLoading = false; }
    );
  }

  onViewQuarterChange(item: any) {
    const quarter = item.value;
    this.previewQuarterLabel = this.getQuarterLabel(quarter);
    this.previewLoading = true;
    this.previewUrl = '';
    this.previewSafeUrl = null;
    this.previewApiUrl = managerApi.eligibleProductsPreview
      + '?fiscalYear=' + quarter.fiscalYear
      + '&quarter=' + quarter.fiscalQuarter;
    this.previewModalOpen = true;
    this.viewQuarterDropdownItems = this.quarterList.map((q: any) => ({
      label: this.getQuarterLabel(q),
      value: q,
      checked: q === quarter,
    }));
    this.fileService.getBlobUrl(this.previewApiUrl).subscribe(
      (blobUrl: string) => {
        this.previewUrl = blobUrl;
        this.previewSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(blobUrl);
        this.previewLoading = false;
      },
      () => { this.previewLoading = false; }
    );
  }

  downloadPreviewFile() {
    if (this.previewApiUrl) {
      this.downloadLoading = true;
      this.fileService.downloadFile(this.previewApiUrl).subscribe(
        () => { this.downloadLoading = false; },
        () => { this.downloadLoading = false; }
      );
    }
  }

  closePreviewModal() {
    this.previewModalOpen = false;
    this.previewUrl = '';
    this.previewSafeUrl = null;
  }
}
